/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import './request';
import '../models/bill';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "beemo": {
        "nested": {
          "api": {
            "nested": {
              "v2": {
                "nested": {
                  "reporting": {
                    "nested": {
                      "BatchRequest": {
                        "fields": {
                          "batchSize": {
                            "type": "int32",
                            "id": 1,
                            "rule": "optional",
                            "options": {
                              "default": 500
                            }
                          },
                          "batchToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "BatchResponse": {
                        "fields": {
                          "nextBatchToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "TransactionsReportRequest": {
                        "fields": {
                          "requestParams": {
                            "type": ".squareup.beemo.api.v2.reporting.RequestParams",
                            "id": 1,
                            "rule": "optional"
                          },
                          "batchRequest": {
                            "type": ".squareup.beemo.api.v2.reporting.BatchRequest",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "TransactionsReportResponse": {
                        "fields": {
                          "batchResponse": {
                            "type": ".squareup.beemo.api.v2.reporting.BatchResponse",
                            "id": 1,
                            "rule": "optional"
                          },
                          "transaction": {
                            "type": ".squareup.beemo.api.v2.models.Transaction",
                            "id": 2,
                            "rule": "repeated"
                          }
                        }
                      },
                      "GetPaymentUnitRequest": {
                        "fields": {
                          "paymentTokenOrBillToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "GetPaymentUnitResponse": {
                        "fields": {
                          "unitToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "billToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.BatchRequest && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.BatchResponse && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.TransactionsReportRequest && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.TransactionsReportResponse && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GetPaymentUnitRequest && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GetPaymentUnitResponse) {
  $root.addJSON(jsonData);
}

/**
 * A message containing request parameters for controlling batching.
 *
 * SOURCE BatchRequest @ squareup/beemo/v2/reporting/detail.proto at 12:1
 */
export const BatchRequest = $root.lookupType('squareup.beemo.api.v2.reporting.BatchRequest');
fixType(BatchRequest);
Builder.createAndAttachToType(BatchRequest);
/**
 * A message containing response parameters for controlling batching.
 *
 * SOURCE BatchResponse @ squareup/beemo/v2/reporting/detail.proto at 28:1
 */
export const BatchResponse = $root.lookupType('squareup.beemo.api.v2.reporting.BatchResponse');
fixType(BatchResponse);
Builder.createAndAttachToType(BatchResponse);
/**
 * This endpoint is deprecated. Please ReportingServiceV3/GetTransactionList instead.
 * The request message for returning transactions for the transactions report.
 *
 * SOURCE TransactionsReportRequest @ squareup/beemo/v2/reporting/detail.proto at 37:1
 */
export const TransactionsReportRequest = $root.lookupType('squareup.beemo.api.v2.reporting.TransactionsReportRequest');
fixType(TransactionsReportRequest);
Builder.createAndAttachToType(TransactionsReportRequest);
/**
 * This endpoint is deprecated. Please ReportingServiceV3/GetTransactionList instead.
 * The response message for returning transactions for the transactions report.
 *
 * SOURCE TransactionsReportResponse @ squareup/beemo/v2/reporting/detail.proto at 48:1
 */
export const TransactionsReportResponse = $root.lookupType('squareup.beemo.api.v2.reporting.TransactionsReportResponse');
fixType(TransactionsReportResponse);
Builder.createAndAttachToType(TransactionsReportResponse);
/**
 * The request message for determining which unit took a payment.
 *
 * SOURCE GetPaymentUnitRequest @ squareup/beemo/v2/reporting/detail.proto at 56:1
 */
export const GetPaymentUnitRequest = $root.lookupType('squareup.beemo.api.v2.reporting.GetPaymentUnitRequest');
fixType(GetPaymentUnitRequest);
Builder.createAndAttachToType(GetPaymentUnitRequest);
/**
 * The response message for determining which unit took a payment.
 *
 * SOURCE GetPaymentUnitResponse @ squareup/beemo/v2/reporting/detail.proto at 62:1
 */
export const GetPaymentUnitResponse = $root.lookupType('squareup.beemo.api.v2.reporting.GetPaymentUnitResponse');
fixType(GetPaymentUnitResponse);
Builder.createAndAttachToType(GetPaymentUnitResponse);